import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Globals } from "../../../../../globals";
import { TPVServices } from "../../../../tpv/services";
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationRoomsCreateTablePage } from '../configuration-rooms-create-table/configuration-rooms-create-table';

/**
 * Generated class for the ConfigurationRoomsCreateTablePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-partial-rooms-create-map',
    templateUrl: 'configuration-partial-rooms-create-map.html',
})
export class ConfigurationPartialRoomsCreateMapPage {
    @ViewChild('boundary') boundary: ElementRef;

    @Input() room;
    @Input() update_state: boolean = false;

    @Input() form: FormGroup;
    public form_table: FormGroup;
    public room_uid: any;
    public table: any;
    public room_name: any;
    public order: any;
    map: boolean = false;
    editable_table: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public fb: FormBuilder,
        public tpvServices: TPVServices,
        public globals: Globals,
        private alertCtrl: AlertController,
        public translate: TranslateService,
        public loadingCtrl: LoadingController) {
        this.room = this.navParams.get('room');
    }

    onDragEnd(event: any, box: any): void {
        // Posición acumulada previa desde el modelo
        const initialX = parseInt(event.source.element.nativeElement.style.left) || 0;
        const initialY = parseInt(event.source.element.nativeElement.style.top) || 0;

        // Obtener el valor de 'transform: translate3d()' del estilo aplicado
        const transform = event.source.element.nativeElement.style.transform;
        const translateValues = transform.match(/translate3d\((-?\d+)px,\s*(-?\d+)px,\s*(-?\d+)px\)/);

        if (translateValues) {
            const translateX = parseInt(translateValues[1], 10);
            const translateY = parseInt(translateValues[2], 10);

            // Nueva posición absoluta sumando desplazamiento actual al valor inicial
            box.map_left = (initialX + translateX) + "px";
            box.map_top = (initialY + translateY) + "px";
        }
    }

    tableClass(table) {
        if (table.map_style) {
            let cssClasses = {
                'tpv-table-green': table.state === 'open',
                'tpv-table-yellow': table.state === 'ticket',
                'tpv-table-red': table.state === 'close',
            }

            return cssClasses;
        } else {
            let cssClasses = {
                'tpv-table-green': table.state === 'open',
                'tpv-table-yellow': table.state === 'ticket',
                'tpv-table-red': table.state === 'close',
                'dnd-square': true,
            }

            return cssClasses;
        }
    }

    tableStyle(table) {
        if (!table.map_top) {
            table.map_top = 0;
        }
        if (!table.map_left) {
            table.map_left = 0;
        }
        let style = {
            'top': table.map_top + 'px',
            'left': table.map_left + 'px',
            'position': 'absolute',
        }
        return style;
    }

    //guarda las posiciones de todas las mesas
    save(tables) {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: this.translate.instant('instant-guardando-posiciones')
        });
        loadingPopup.present();
        this.editable_table = undefined;
        //recorrer las mesas
        for (let table of tables) {
            //check map_style existeix
            if (!table.map_style) {
                table.map_style = 'dnd-square';
            }
            this.tpvServices.afs.collection('tables').doc(table.UID).update({
                'map_style': table.map_style,
                'map_top': parseInt(table.map_top),
                'map_left': parseInt(table.map_left),
            })
        }
        //recuperar las mesas otra vez
        this.getTablesAsync();
        loadingPopup.dismiss();
    }

    delete() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-comedor'),
            message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.GAtrackView('Configuration', 'Configuration - Rooms - delete', this.globals.restaurant.email, 'Delete', 'Delete room', 'Configuration', this.room.name);
                        this.tpvServices.afs.doc('rooms/' + this.room.UID).delete();
                        this.navCtrl.pop();
                    }
                }
            ]
        });
        alert.present();

    }

    createTable() {
        //this.save(this.tpvServices.tables_tmp);
        this.navCtrl.push(ConfigurationRoomsCreateTablePage, {
            room_uid: this.room.UID,
            room_name: this.room.name,
            update: false,
        });
    }

    //Abre el cuadro de edicion poniendo la info de una mesa
    openSettings(table) {
        this.editable_table = table;
    }
    //setea valor LEFT de 1 a 1 o el valor escrito
    setMapLeft(value) {
        this.editable_table.map_left = parseInt(this.checkNoOutMap('left', value));
    }
    //setea valor TOP de 1 a 1 o el valor escrito
    setMapTop(value) {
        this.editable_table.map_top = parseInt(this.checkNoOutMap('top', value));
    }
    //suma o resta top
    controllerTop(operator, value) {
        var map_top = parseInt(this.editable_table.map_top);
        if (operator == 'append') {
            map_top += parseInt(value);
        } else {
            map_top -= parseInt(value);
        }
        this.editable_table.map_top = parseInt(this.checkNoOutMap('top', map_top));

    }
    //suma o resta left
    controllerLeft(operator, value) {
        var map_left = parseInt(this.editable_table.map_left);
        if (operator == 'append') {
            map_left += parseInt(value);
        } else {
            map_left -= parseInt(value);
        }
        this.editable_table.map_left = parseInt(this.checkNoOutMap('left', map_left));

    }
    //comprueba que valores no salgan del cuadro
    checkNoOutMap(position, value) {
        var limits = this.limits();
        if (position == 'top') {
            if (value < 0) {
                return 0;
            } else if (value > limits.value_height) {
                return limits.value_height;
            } else {
                return value;
            }
        } else {
            if (value < 0) {
                return 0;
            } else if (value > limits.value_width) {
                return limits.value_width;
            } else {
                return value;
            }
        }

    }
    //seteamos la forma de la mesa
    setTableForm(value) {
        this.tpvServices.afs.collection('tables').doc(this.editable_table.UID).update({
            'map_style': value,
        }).then(ret => {
            this.editable_table.map_style = value;
            this.editable_table.map_top = parseInt(this.checkNoOutMap('top', this.editable_table.map_top));
            this.editable_table.map_left = parseInt(this.checkNoOutMap('left', this.editable_table.map_left));

        })
    }
    //guardado de la mesa
    fastSave() {
        this.tpvServices.afs.collection('tables').doc(this.editable_table.UID).update({
            'map_top': parseInt(this.editable_table.map_top),
            'map_left': parseInt(this.editable_table.map_left),
        }).then(ret => {
            this.editable_table = undefined;
        })
    }
    //cerrar columna de edicion
    close() {
        this.editable_table = undefined;
    }

    //nos devuelve el limite que tienen los elemenos dentro del mapa
    limits() {
        var height = this.getHeightMapStyle();
        var width = this.getWidthMapStyle();
        //init
        var value_height = 665;
        var value_width = 920;
        //height
        if (height == 100) {
            value_height = 420;
        } else if (height == 200) {
            value_height = 320;
        } else if (height == 300) {
            value_height = 220;
        }
        //width
        if (width == 100) {
            value_width = 1220;
        } else if (width == 200) {
            value_width = 1120;
        } else if (width == 300) {
            value_width = 1020;
        }

        return { value_height: value_height, value_width: value_width }
    }

    //devuelve el width en base de la forma
    getWidthMapStyle() {
        if (this.editable_table.map_style == 'dnd-square') {
            return 100;
        } else if (this.editable_table.map_style == 'dnd-circle') {
            return 100;
        } else if (this.editable_table.map_style == 'dnd-rectangle') {
            return 200;
        } else if (this.editable_table.map_style == 'dnd-rectangle-vertical') {
            return 100;
        } else if (this.editable_table.map_style == 'dnd-circle-big') {
            return 200;
        } else if (this.editable_table.map_style == 'dnd-rectangle-big') {
            return 300;
        } else if (this.editable_table.map_style == 'dnd-rectangle-big-vertical') {
            return 100;
        } else {
            return 100;
        }
    }
    //devuelve el height en base de la forma
    getHeightMapStyle() {
        if (this.editable_table.map_style == 'dnd-square') {
            return 100;
        } else if (this.editable_table.map_style == 'dnd-circle') {
            return 100;
        } else if (this.editable_table.map_style == 'dnd-rectangle') {
            return 100;
        } else if (this.editable_table.map_style == 'dnd-rectangle-vertical') {
            return 200;
        } else if (this.editable_table.map_style == 'dnd-circle-big') {
            return 200;
        } else if (this.editable_table.map_style == 'dnd-rectangle-big') {
            return 100;
        } else if (this.editable_table.map_style == 'dnd-rectangle-big-vertical') {
            return 300;
        } else {
            return 100;
        }
    }

    async getTablesAsync() {
        this.tpvServices.tables_tmp = await this.tpvServices.getTablesRoomAsync(this.globals.restaurant_uid, this.room.UID);
    }

    limitCharsClass(table) {
        let cssClasses = {};
        if (table.map_style) {
            cssClasses = {
                'limitCharsRooms-square': table.map_style === 'dnd-square',
                'limitCharsRooms-circle': table.map_style === 'dnd-circle',
                'limitCharsRooms-rectangle': table.map_style === 'dnd-rectangle',
                'limitCharsRooms-rectangle-vertical': table.map_style === 'dnd-rectangle-vertical',
                'limitCharsRooms-circle-big': table.map_style === 'dnd-circle-big',
                'limitCharsRooms-rectangle-big': table.map_style === 'dnd-rectangle-big',
                'limitCharsRooms-rectangle-big-vertical': table.map_style === 'dnd-rectangle-big-vertical',
            }
        } else {
            cssClasses = {
                'limitCharsRooms-square': 'dnd-square',
            }
        }
        return cssClasses;
    }

    selectClass(table) {
        let cssClasses = {};
        if (table.map_style) {
            cssClasses = {
                'table-square': table.map_style === 'dnd-square',
                'table-circle': table.map_style === 'dnd-circle',
                'table-rectangle': table.map_style === 'dnd-rectangle',
                'table-rectangle-v': table.map_style === 'dnd-rectangle-vertical',
                'table-circle-big': table.map_style === 'dnd-circle-big',
                'table-rectangle-big': table.map_style === 'dnd-rectangle-big',
                'table-rectangle-v-big': table.map_style === 'dnd-rectangle-big-vertical',
            }
        } else {
            cssClasses = {
                'table-square': 'dnd-square',
            }
        }
        return cssClasses;
    }

    organizeTables() {
        const container = document.getElementsByClassName('example-boundary')[0];
        const containerWidth = container.clientWidth; // 1320
        const containerHeight = container.clientHeight; // 520
        const margin = 5; // Espacio entre mesas
        let currentX = 0; // Posición x actual
        let currentY = 0; // Posición y actual
        let rowHeight = 0; // Altura máxima de la fila actual
        let all_tables = true; //Si he han podido organizar todas las mesas

        this.room.content.forEach((table) => {
            if (table.map_insert === undefined || table.map_insert === true) {
                let tableWidth, tableHeight;

                // Definir ancho y alto de la mesa según el tipo
                switch (table.map_style) {
                    case 'dnd-square':
                        tableWidth = 100;
                        tableHeight = 100;
                        break;
                    case 'dnd-circle':
                        tableWidth = 100;
                        tableHeight = 100;
                        break;
                    case 'dnd-circle-big':
                        tableWidth = 200;
                        tableHeight = 200;
                        break;
                    case 'dnd-rectangle':
                        tableWidth = 200;
                        tableHeight = 100;
                        break;
                    case 'dnd-rectangle-big':
                        tableWidth = 300;
                        tableHeight = 100;
                        break;
                    case 'dnd-rectangle-v':
                        tableWidth = 100;
                        tableHeight = 200;
                        break;
                    case 'dnd-rectangle-v-big':
                        tableWidth = 100;
                        tableHeight = 300;
                        break;
                    default:
                        tableWidth = 100;
                        tableHeight = 100;
                }

                // Si no cabe en el espacio horizontal, mover a la siguiente fila
                if (currentX + tableWidth + margin > containerWidth) {
                    currentX = 0; // Reiniciar posición x
                    currentY += rowHeight + margin; // Mover hacia abajo, incluyendo el margen
                    rowHeight = 0; // Resetear altura de la fila
                }
                if (currentY + tableHeight > containerHeight) {
                    table.map_insert = false;
                    all_tables = false;
                } else {
                    // Posicionar la mesa con el margen aplicado
                    table.map_left = currentX;
                    table.map_top = currentY;

                    // Actualizar posición para la próxima mesa
                    currentX += tableWidth + margin; // Avanzar en el eje x, incluyendo el margen
                    rowHeight = Math.max(rowHeight, tableHeight); // Actualizar altura de fila según la mesa más alta
                }
            }
        });
        if (!all_tables) {
            this.globals.launchToast('No se han podido organizar todas las mesas', 3000, 'top');
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-rooms/configuration-rooms-create/configuration-partial-rooms-create-map/configuration-partial-rooms-create-map.ts